import { cn } from '@osmosis/tailwind-ui/helpers/classes';
import * as React from 'react';
/**
 *  Stitcher icon.
 */
const Stitcher = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 15"
    {...props}
    className={cn('w-full', props.className)}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#DE822E" d="M21.733 3.926h6.487V.038h-6.487z" />
      <path fill="#F3C229" d="M14.505 3.926h6.487V1.982h-6.487z" />
      <path fill="#532455" d="M7.277 3.926h6.488V.91H7.277z" />
      <path fill="#3A8EBA" d="M.021 3.926h6.515V2.869H.02z" />
      <path fill="#B2352B" d="M28.961 3.926h6.514V2.372h-6.514z" />
      <path fill="#DE822E" d="M21.733 13.578h6.487v-2.122h-6.487z" />
      <path fill="#F3C229" d="M14.505 14.999h6.487v-3.543h-6.487z" />
      <path fill="#532455" d="M7.277 13.578h6.488v-2.122H7.277z" />
      <path fill="#3A8EBA" d="M.021 14.4h6.515v-2.944H.02z" />
      <path fill="#B2352B" d="M28.961 12.613h6.515v-1.157H28.96z" />
      <path
        fill="#0A0B09"
        d="M5.857 10.175V6.32H4.405V5.207h4.26V6.32H7.198v3.855H5.857zm-3.927.042c-1.143 0-1.85-.518-1.879-.54l-.03-.023.392-1.209.06.058c.006.006.61.573 1.536.573.651 0 .739-.177.739-.35 0-.317-.426-.43-.919-.563C1.094 7.965.178 7.719.178 6.67c0-.98.704-1.519 1.984-1.519.85 0 1.626.398 1.93.991l.022.043-1.039.654-.028-.045c-.193-.31-.561-.502-.962-.502-.503 0-.503.227-.503.301 0 .282.406.394.876.525.755.21 1.694.47 1.694 1.56 0 1.004-.7 1.508-2.142 1.539h-.08zm7.44-.043h1.343V5.207H9.37v4.967zm3.5 0V6.32h-1.45V5.207h4.259V6.32h-1.466v3.855h-1.341zm11.36 0v-1.91h-1.909v1.91H20.98V5.208h1.342v1.986h1.91V5.207h1.341v4.968H24.23zm-5.815.05c-1.704 0-2.643-.91-2.643-2.56 0-1.542 1.013-2.499 2.643-2.499 1.686 0 2.02.953 2.034.994l.013.04-1.045.648-.028-.046a1.176 1.176 0 0 0-.974-.502c-.857 0-1.274.446-1.274 1.364 0 .908.453 1.415 1.275 1.427h.016c.596 0 .963-.503.967-.508l.028-.04 1.036.633-.015.04c-.015.042-.397 1.008-2.033 1.008zm7.876-.049V5.207h3.912v1.078h-2.57v.888h1.556v1.022h-1.556v.902h2.57v1.078h-3.912m6.897-2.53h-.99v-1.36h.99c.534 0 .794.221.794.677 0 .46-.26.683-.794.683zm1.214.809c.57-.306.86-.822.86-1.534 0-1.105-.737-1.713-2.074-1.713h-2.332v4.968h1.342V8.723h.883l.813 1.452h1.581l-1.073-1.721z"
      />
    </g>
  </svg>
);

export default Stitcher;
